import networkParams from './networkParams'

const gasTokens = Object.keys(networkParams).reduce((acc, chainId) => {
  acc[chainId] = networkParams[chainId][0].nativeCurrency.symbol
  return acc
}, {})

export default gasTokens
